import * as i0 from '@angular/core';
import * as i1 from './dropdown.module';
import * as i2 from './dropdown';
export const NgbDropdownModuleNgFactory:i0.NgModuleFactory<i1.NgbDropdownModule> = (null as any);
var _decl0_0:i2.NgbDropdown = (<any>(null as any));
var _decl0_1:i2.NgbDropdownAnchor = (<any>(null as any));
var _decl0_2:i2.NgbDropdownToggle = (<any>(null as any));
var _decl0_3:i2.NgbDropdownMenu = (<any>(null as any));
